import login from '@/pages/adminPage/login.vue';
import adminCenter from '@/pages/adminPage/index.vue';
import dataCenter from '@/pages/adminPage/dataCenter/index.vue';
import industryIdynamics from '@/pages/adminPage/industryIdynamics/index.vue';
import industryIdynamicsList from '@/pages/adminPage/industryIdynamics/list.vue';
import industryIdynamicsAdd from '@/pages/adminPage/industryIdynamics/add.vue';
import industryIdynamicsEdit from '@/pages/adminPage/industryIdynamics/edit.vue';
import allianceActivities from '@/pages/adminPage/allianceActivities/index.vue';
import allianceActivitiesAdd from '@/pages/adminPage/allianceActivities/add.vue';
import allianceActivitiesList from '@/pages/adminPage/allianceActivities/list.vue';
import allianceActivitiesEdit from '@/pages/adminPage/allianceActivities/Edit.vue';
import productManagement from '@/pages/adminPage/productManagement/index.vue';
import commonModule from '@/pages/adminPage/commonModule/index.vue';
import userCenter from '@/pages/adminPage/userCenter/index.vue';
import testModule from '@/pages/adminPage/test/index.vue';
import allianceManagement from '@/pages/adminPage/allianceManagement/index.vue';
/* eslint-disable */
const AdminRouter = [{
    path: '/login_gate',
    name: 'login_gate',
    component: login
  },
  {
    path: '/admin',
    name: 'admin',
    component: adminCenter,
    children: [{
        path: '/',
        redirect: {
          path: 'dataCenter'
        },
      },
      {
        path: 'dataCenter',
        name: 'dataCenter',
        component: dataCenter
      }, {
        path: 'industryIdynamics',
        name: 'industryIdynamics',
        children: [{
            path: '/',
            name: 'industryIdynamicsList',
            component: industryIdynamicsList
          },
          {
            path: 'add',
            name: 'industryIdynamicsAdd',
            component: industryIdynamicsAdd
          },
          {
            path: 'edit/:newsId',
            name: 'industryIdynamicsEdit',
            component: industryIdynamicsEdit
          }
        ],
        component: industryIdynamics
      }, {
        path: 'allianceActivities',
        name: 'allianceActivities',
        component: allianceActivities,
        children: [{
            path: '/',
            name: 'allianceActivitiesList',
            component: allianceActivitiesList
          },
          {
            path: 'add',
            name: 'allianceActivitiesAdd',
            component: allianceActivitiesAdd
          },
          {
            path: 'edit/:newsId',
            name: 'allianceActivitiesEdit',
            component: allianceActivitiesEdit
          },
        ]
      },
      {
        path: 'productManagement',
        name: 'productManagement',
        component: productManagement
      },
      {
        path: 'commonModule',
        name: 'commonModule',
        component: commonModule
      },
      {
        path: 'userCenter',
        name: 'userCenter',
        component: userCenter
      },
      {
        path: 'allianceManagement',
        name: 'allianceManagement',
        component: allianceManagement
      },
      {
        path: 'testModule',
        name: 'testModule',
        component: testModule
      },
    ]
  }
]

;
export default [
  ...AdminRouter
]



// WEBPACK FOOTER //
// ./src/router/admin.js